var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"co-skeleton-wrapper",class:this.classes},[_c('div',{staticClass:"co-skeleton",style:({
            width: this.width,
            height: this.height,
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }